export const rick = {
  quote: '"nothing you do matters ! your existence is a lie "',
  about: `He is a genius scientist whose alcoholism and reckless, nihilistic behavior are a source of concern for his daughter's family, as well as the safety of their son, Morty`,
};
export const morty = {
  quote: 'You son of a b*tch ! im in',
  about:
    '"He is the grandson of Rick and is often forced to tag along on his various misadventures. Morty attends Harry Herpson High School along with his sister, Summer."',
  icon: `url('../images/icons/mortyIcon.png')`,
  largeImg: `url('./images/morty.png')`,
};
export const beth = {
  quote: `"let's save the measuring for when our d*cks are out , its time to save a life"`,
  about:
    ' A dedicated veterinary horse surgeon with superiority complex and struggles with her husband over his contributions to their marriage',
  icon: `url('./images/icons/bethIcon.png')`,
  largeImg: `url('./images/beth.png')`,
};
export const jerry = {
  quote: `"life is effort and i'll stop when i die"`,
  about:
    'He has a habit of quitting when things get too difficult. Despite being generally passive and weak most of the time, Jerry has the ability to channel the inner-strength to face his fears',
  icon: `url('./images/icons/jerryIcon.png')`,
  largeImg: `url('./images/jerry.png')`,
};
export const summer = {
  quote: `"you dont love people in hopes of reward,dad. you love them unconditionally"`,
  about:
    'She is the daughter of Jerry Smith ,Summer seems jealous of the fact that her grandfather Rick chooses to go on adventures with her brother Morty',
  icon: `url('./images/icons/summerIcon.png')`,
  largeImg: `url('./images/summer.png')`,
};
export const mrmeeseeks = {
  quote: `"I’m Mr. Meeseeks. Look at me. The only thing that’s clear is that choking up is the one true solution"`,
  about:
    'Meeseeks are creatures who are created to serve a singular purpose for which they will go to any length to fulfill. After they serve their purpose, they expire and vanish into the air. ',
  icon: `url('./images/icons/mrmeeseeksIcon.png')`,
  largeImg: `url('./images/mrmeeseeks.png')`,
};
export const mrpoopy = {
  quote: `"he's sorry you didnt have bad memories of him"`,
  about:
    'Mr. Poopybutthole is a very good friend to the Smith Family, from another dimension (where he is a planet wide superstar) who has taken refuge with the Smiths so he can live a normal life',
  icon: `url('./images/icons/mypoopyIcon.png')`,
  largeImg: `url('./images/mrpoopy.png')`,
};
